"use client"
import React, { ReactChild, useCallback, useEffect, useRef, useState } from "react"
import { PlanType } from "~/models/Plan"
import { NaviLink } from "~/components/organisms/NaviLink";
import { PlanSelect } from "~/components/organisms/PlanSelect"

/*
    簡易版上部の生成用コンポーネント
    props
        data:csvProductデータ
 */

interface Props {
  planType: string,
  children?: ReactChild | ReactChild[],
  onChange?: (data: `${PlanType}` | null) => void,
}

export function SimpleHeaderArea(props: Props) {
  const { planType, children, onChange } = props
  const [contentCss, setContentCss] = useState<{}>({})
  const ref = useRef<HTMLDivElement>(null)

  const [isHide, setIsHide] = useState(true)
  const isRunning = useRef(false)
  let currentPosition = 0
  const isScrollToggle = useCallback(() => {
    if (isRunning.current) return
    isRunning.current = true
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    requestAnimationFrame(() => {

      if (currentPosition >= scrollTop) {
        setIsHide(true)
      } else {
        setIsHide(false)
      }
      currentPosition = scrollTop
      isRunning.current = false
    })
  }, [])

  useEffect(() => {
    document.addEventListener("scroll", isScrollToggle, { passive: true })
    return () => {
      // @ts-ignore
      document.removeEventListener("scroll", isScrollToggle, { passive: true })
    }
  }, [])

  useEffect(() => {
    if (!ref.current) {
      return
    }
    const { height } = ref.current.getBoundingClientRect()
    if (isHide) {
      setContentCss({
        top: "0px", animation: "2s ease-in"
      })
    } else {
      setContentCss({
        top: `-${height}px`, animation: "2s ease-in"
      })
    }
  }, [isHide, ref.current])

  return (
    <>
      <div className="persistent" id="persistent" style={contentCss} ref={ref}>
        <div className="inner">
          <NaviLink>
            <div className="pack-info-area">
              <div className="pack-info">
                {children}
              </div>
              <div className="pack-info-select-plan">
                <PlanSelect data={planType} onChange={onChange} />
              </div>
            </div>
          </NaviLink>
        </div>
      </div>
    </>
  )
}
